import CheckCircle from "@mui/icons-material/CheckCircle";
import Pending from "@mui/icons-material/PendingOutlined";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import {
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
  useTheme,
} from "@mui/material";
import { prettyPrintDateTimeMed } from "util/dates";
import { DocumentButton } from "./DocumentButton";
import { ActivityStepStatus, useActivitySteps } from "../useActivitySteps";

export const ActivityStepper = () => {
  const steps = useActivitySteps();
  if (!steps) return null;

  return (
    // Stepper maintains an "active step" to control expanded state
    // because we have the documents in the StepContent
    // we need to opt out of that behavior and force always expanded
    <Stepper orientation="vertical">
      {steps.map(({ status, timestamp, title, documents }, index) => (
        <Step
          key={index}
          completed={status === ActivityStepStatus.Completed}
          active={status === ActivityStepStatus.InProgress}
          expanded={true}
        >
          <StepLabel
            StepIconComponent={(props) => <StepIcon {...props} />}
            optional={
              timestamp &&
              status === ActivityStepStatus.Completed && (
                <Typography variant="caption">
                  {prettyPrintDateTimeMed(timestamp)}
                </Typography>
              )
            }
          >
            {title}
          </StepLabel>
          <StepContent>
            <DocumentButton documents={documents} />
          </StepContent>
        </Step>
      ))}
    </Stepper>
  );
};

const StepIcon = ({
  completed,
  active,
}: {
  completed?: boolean;
  active?: boolean;
}) => {
  const theme = useTheme();

  if (completed) {
    return <CheckCircle style={{ color: theme.palette.success.light }} />;
  }
  if (active) {
    return <Pending style={{ color: theme.palette.warning.light }} />;
  }

  return <RadioButtonUnchecked color="disabled" />;
};
